import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../core/api.service';
import { UserService } from '../core/user.service';
import { ChargebeeService } from '../shared/services/chargebee.service';
import { ChargebeeProvisionData } from '../shared/models/provision.model';
import { environment } from 'src/environments/environment';
import { BlendService } from '../shared/services/blend.service';
import { SyncCookieService } from '../core/sync-cookie.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  protected chargebeeProvisionData: ChargebeeProvisionData;
  constructor(
    private route: ActivatedRoute,
    private chargebeeService: ChargebeeService,
    private apiService: ApiService,
    private blendService: BlendService,
    private syncCookieService: SyncCookieService,
  ) { }
  async ngOnInit() {
    try{
      await this.chargebeeService.refreshEntitlements();
    }catch (error) {
      console.error('Error refreshing entitlements: or user is not login', error);
    }
    this.chargebeeProvisionData = await this.apiService.execute('getchargebeeprovisiondata', { 
      sub_id: this.route.snapshot?.queryParams?.sub_id,
      invoice_id: this.route.snapshot?.queryParams?.invoice_id,
      transaction_id: this.route.snapshot?.queryParams['transactions[0]'],
      user_id:this.route.snapshot?.queryParams?.user_id
    }) as any;
    
    let accountType = this.chargebeeProvisionData.product_price > 0 ? 'paid' : 'free';
    if (this.chargebeeProvisionData.is_trial) {
      accountType = 'trial';
    }
    let type = this.route.snapshot?.queryParams?.type;
    if (type === 'upgrade' && this.route.snapshot?.queryParams?.purchase_seats == 1) {
      type = 'purchase_seats';
    }
    const thankyouValues = {
      accountType,
      type,
      chargebeeCustomerId: this.chargebeeProvisionData.customer_id,
      userId: this.route.snapshot?.queryParams?.user_id?.toString?.(),
      email: this.chargebeeProvisionData.email_sha256,
      sku: this.chargebeeProvisionData.item_price_id,
      planName: this.chargebeeProvisionData.plan_name,
      currency: this.chargebeeProvisionData.currency_code,
      frequency: this.chargebeeProvisionData.billing_period_unit,
      qty: this.chargebeeProvisionData.quantity?.toString?.(),
      trial: this.chargebeeProvisionData.is_trial ? 'Yes' : 'No',
      pricing_model: this.chargebeeProvisionData.pricing_model,
      productPrice: this.chargebeeProvisionData.product_price?.toString?.(),
      amount: this.chargebeeProvisionData.sub_total.toString(),
      discountAmount: this.chargebeeProvisionData.discount?.toString?.(),
      taxAmount: this.chargebeeProvisionData.tax?.toString?.(),
      totalAmount: this.chargebeeProvisionData.total?.toString?.(),
      country: this.chargebeeProvisionData.billing_address?.country,
      province: this.chargebeeProvisionData.billing_address?.state,
      sub_id: this.chargebeeProvisionData.subscription_id,
      adminId: this.chargebeeProvisionData?.team_id ?? '',
      orderId: this.chargebeeProvisionData?.invoice_id ?? '',
    };
       const Attribution_Mtags = this.syncCookieService.getMarketingRef();
        await this.blendService.trackPurchaseCompleted(thankyouValues.userId, {
          "Product_Billing": thankyouValues.frequency  === 'month' ? 'Monthly' : 'Annual',
          "Product_Discount": this.getUSDValue(this.chargebeeProvisionData.discount),
          "Product_OrderID": thankyouValues.orderId,
          "Product_Price": this.getUSDValue(this.chargebeeProvisionData.product_price),
          "Product_SKU": thankyouValues.sku,
          "Product_Type": "Upgrade",
          "Signup_from": "Website",
          "Signup_type": accountType,
          "seats": this.chargebeeProvisionData.quantity,
          "Attribution_Mtags": Attribution_Mtags ?? "",
          "Product_Family": this.chargebeeProvisionData?.product_family ?? "",
          "platform": "website",
          "team_id": this.chargebeeProvisionData?.team_id ?? null,
        });
        // adding timeout before redirecting so mixpanel event can be triggered.
        setTimeout(() => {
          window.location.href = environment.hubspotHost + '/thank-you-for-choosing-sync?' + new URLSearchParams(thankyouValues).toString();
        }, 1000);
  }

  private getUSDValue(value) {
    if (value) {
      return +(value/100).toFixed(2);
    }
    return 0;
  }
}